<template>
    <div class="Login">
        <!-- 로고 -->
        <div><img src="@/assets/images/login-bg.png" width="100%"></div>
        <!-- s: contents -->
        <div class="contents-area-noscroll">
            <div class="login-wrap">
                <input type="text"
                       placeholder="아이디"
                       v-model="userId"
                       maxlength="10"
                       class="login-input-box mrg-top-10 input-user-id"
                       @focusin="isFooterDisplay(false)"
                       @focusout="isFooterDisplay(true)" />
                <input type="password"
                       placeholder="비밀번호"
                       v-model="userPw"
                       maxlength="14"
                       class="login-input-box mrg-top-20 input-user-pw mrg-btm-30"
                       @focusin="isFooterDisplay(false)"
                       @focusout="isFooterDisplay(true)"
                       @keyup.enter="loginFun"/>
                <p class="login-result mrg-btm-10"
                   v-show="resultErrorMsg"
                   v-html="resultErrorMsg"></p>
                <button @click="loginFun"
                        class="btn-login width-100">
                    로그인
                </button>
                <div class="flex justify-between login-other">
                    <ul class="flex">
                        <li><a @click.prevent="idFindSlideView">아이디찾기</a></li>
                        <li><a @click.prevent="pwFindSlideView">비밀번호찾기</a></li>
                    </ul>
                    <router-link tag="a" to="/agree">
                        회원가입
                    </router-link>
                </div>
                <!-- 약관 -->
                <div class="flex justify-around login-terms" v-show="bFooter">
                    <div @click="termsSlideView('use')">이용약관</div>
                    <div @click="termsSlideView('personal')">개인정보 취급방침</div>
                </div>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>

export default {
    name: 'Login',
    data() {
        return {
            userId : '',        // 아이디
            userPw : '',        // 비밀번호
            resultErrorMsg:'',  // error 메시지
            bFooter:true,       // 약관 노출여부(input focus 시 약관 안보이게 처리)
        }
    },
    // $el 생성전
    created(){
        // local storage 초기화
        this.$store.commit('clear');
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            window.Android.exitApp();
        },
        // 로그인
        loginFun(){
            let formData = new FormData();
            formData.append('strUserId', this.userId);
            formData.append('strPassWord', this.userPw);
            formData.append('bAutoLogin', 'Y');

            this.ajaxPost('/api/v1/login', formData,this.loginFunResult);

        },
        // 로그인 결과
        loginFunResult(response){
            let result = response.result;
            if (result.code == 0){
                this.$store.commit('setAuthUserSId',result.loginInfo.strAuthUserSId);
                this.resultErrorMsg = '';
                this.gnbAllDataFunc();
            }else{
                this.resultErrorMsg = result.resultNoti.message;
            }

        },
        // 아이디찾기 Slide
        idFindSlideView(){
            const panel =this.$showPanel({
                component: () => import('@/views/find/IdSearch.vue'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.userId) this.userId = result.userId;
            });
        },
        // 비밀번호찾기 Slide
        pwFindSlideView(){
            const panel =this.$showPanel({
                component: () => import('@/views/find/PwSearch.vue'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                console.log(result)
                window.callbackBackKey = this.callbackBackKey;
            });
        },
        // 약관 Slide
        termsSlideView(result){
            let props = {
                pResult : result,
            };
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Terms.vue'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                console.log(result)
                window.callbackBackKey = this.callbackBackKey;
            });
        },
        // 하단 약관 노출여부
        isFooterDisplay(obj){
            let vm=this;
            if (obj == true){
                if (this.userId && this.userPw){
                    vm.bFooter = false;
                }else{
                    vm.bFooter = true;
                }
            }else{
                vm.bFooter = false;
            }
        }
    }
}
</script>

<style scoped>
    body {background: none}
    .login-wrap {width: 100%; margin: 0 auto; padding:0}
    .login-input-box {width: 100%; padding: 10px 0;height: 30px;line-height: 30px;border: none;border-bottom: 2px solid #017ff0;color: #000;font-size: 1.3333rem;font-weight: 500;text-indent: 35px;border-radius: 0px;}
    .input-user-id{background: url(../assets/images/ico_userid_off.png) 0 center no-repeat;background-size: 15px 16px;border-bottom: 2px solid #e5e5e5; background-position: 9px 15px;}
    .input-user-id:focus{background-image: url(../assets/images/ico_userid_on.png);border-bottom: 2px solid #017ff0;}
    .input-user-pw{background: url(../assets/images/ico_userpw_off.png) 0 center no-repeat;background-size: 15px 16px;border-bottom: 2px solid #e5e5e5; background-position: 9px 15px;}
    .input-user-pw:focus{background-image: url(../assets/images/ico_userpw_on.png);border-bottom: 2px solid #017ff0;}
    .btn-login {background: #017ff0;color: #fff;height: 58px;line-height: 58px;font-size: 16px;border-radius: 29px;margin-bottom: 30px; border: 0;}
    .login-wrap .login-result { padding: 0; font-size: 1.0rem; color: #ec6464; text-align: center; }
    .login-other{color: #017ff0;font-weight: 500;font-size: 13px;}
    .login-other ul>li{padding-left: 0px; padding-right: 10px; border-right: 1px solid #dadada; color: #000;}
    .login-other ul>li:last-child{padding-left: 10px; border-right: none}
    .login-terms{background-color: #f7f7fa;position: fixed;left: 0;right: 0;bottom: 0;height: 70px;line-height: 70px;color: #000;font-weight: 500;font-size: 15px;}
</style>
